import { Flex, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { pxToRem } from 'styles/pxToRem';

type B2bRegistrationSectionHeadingProps = {
  children: ReactNode;
  dir?: 'ltr' | 'rtl';
};

/** Shared RTL section title: coral start rule; scales down on narrow viewports. */
export const B2bRegistrationSectionHeading = ({
  children,
  dir = 'rtl',
}: B2bRegistrationSectionHeadingProps) => (
  <Flex
    w='full'
    maxW='100%'
    minH={{ base: '44px', lg: '47px' }}
    h='auto'
    gap='10px'
    pl='16px'
    pr='16px'
    py={{ base: 1, lg: 0 }}
    align='center'
    justify='flex-start'
    opacity={1}
    borderInlineStartWidth='3px'
    borderInlineStartStyle='solid'
    borderInlineStartColor='#FF5C4F'
    boxSizing='border-box'
    dir={dir}
  >
    <Text
      as='h2'
      dir={dir}
      flex='1'
      minW={0}
      fontFamily="'Noto Sans Arabic', 'Noto Sans', sans-serif"
      fontWeight='600'
      fontStyle='normal'
      fontSize={{ base: pxToRem(22), lg: pxToRem(36) }}
      lineHeight={{ base: 1.25, lg: 1 }}
      letterSpacing='0'
      textAlign='start'
      color='dark.D800'
      sx={{ leadingTrim: 'none' }}
    >
      {children}
    </Text>
  </Flex>
);
